module.exports = __webpack_public_path__ + "static/media/Parkland_F_HC.72b327aa.png";